// src/hooks/use-login.js

import { useLocation, useNavigate } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import { useLoginMutation } from '../redux/features/authApi';

import { setAuth } from '../redux/slices/authApiSlice';

import { api } from '../redux/services/api';

import { appURL } from '../components/Data/baseURL';

export default function useLogin() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [login, { isLoading }] = useLoginMutation();

  const from = location.state?.from?.pathname || appURL;

  const onSubmit = async ({ email, password }) => {
    try {
      await login({
        email,
        password,
      }).unwrap();

      /*
       * Remove cached data that may belong to a previous user.
       */
      dispatch(api.util.resetApiState());

      dispatch(setAuth());

      navigate(from, {
        replace: true,
      });

      toast.success(() => t('toast.logged_in_successfully'));

      return true;
    } catch (error) {
      console.error('Login failed:', error);

      toast.error(t('toast.no_active_account_found_or_credentials_not_valid'));

      return false;
    }
  };

  return {
    isLoading,
    onSubmit,
  };
}
